import { render } from "./ResetPass.vue?vue&type=template&id=1bd71c31&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=1bd71c31&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd71c31"]])

export default __exports__